import cs from 'classnames';

import { pluralize } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

const SelectionActionsBar = ({ selectedCount, onClearSelection, actions, isHidden = false }) => {
  if (!actions) return null;

  return (
    <div
      className={cs(
        'absolute bottom-12 left-[127px] right-[127px] h-[48px]',
        'flex items-center justify-between gap-4 p-3',
        'z-40 rounded-lg bg-neutral-700',
        'transition-all duration-300 ease-out',
        {
          'hidden': isHidden,
          'pointer-events-auto opacity-100 translate-y-0': selectedCount > 0 && !isHidden,
          'pointer-events-none translate-y-full opacity-0': selectedCount === 0 || isHidden
        }
      )}>
      <div className="flex items-center gap-3">
        <Icon
          icon="close-linear"
          color="white"
          size={16}
          onClick={onClearSelection}
          className="cursor-pointer rounded hover:opacity-70"
        />

        <span className="text-xs font-500 text-white">
          {selectedCount} {pluralize('substep', selectedCount)} selected
        </span>
      </div>

      <div
        className={cs(
          'flex origin-center items-center gap-3 opacity-100',
          'transition-transform duration-300 ease-out will-change-transform',
          {
            'scale-0 delay-300': selectedCount === 0,
            'scale-100': selectedCount > 0
          }
        )}>
        {typeof actions === 'function' ? actions() : actions}
      </div>
    </div>
  );
};

export default SelectionActionsBar;
